import {AfterContentInit, ChangeDetectionStrategy, Component, ContentChildren, Input, OnChanges, OnDestroy, QueryList} from '@angular/core';
import {queryListToObservable} from 'app/core/helpers/observable';
import {PageTitleItemComponent} from 'app/shared/components/page-title-item/page-title-item.component';
import {Observable, Subscription} from 'rxjs';
import {LayoutService} from 'app/core/services/layout.service';

@Component({
    selector: 'page-title',
    templateUrl: './page-title.component.html',
    styleUrls: ['./page-title.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageTitleComponent implements AfterContentInit, OnChanges, OnDestroy {
    @Input() title: string | null;

    @ContentChildren(PageTitleItemComponent) titleItemsList: QueryList<PageTitleItemComponent>;

    titleItems: Observable<Array<PageTitleItemComponent>>;

    breadCrumbs = false;
    sub = Subscription.EMPTY;

    constructor(public layoutService: LayoutService) {}

    ngAfterContentInit() {
        this.titleItems = queryListToObservable(this.titleItemsList);
        this.sub = this.titleItems.subscribe(list => {
            this.breadCrumbs = list.length > 0;
            this.layoutService.titleItems$.next(list);
        });
    }

    ngOnChanges() {
        if (!this.title.includes(':')) {
            this.layoutService.title$.next(this.title);
            return;
        }

        this.layoutService.title$.next(this.title.replace(':', ' -'));
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }
}
